const dataAccessMethods = require('../../dataAccessMethods');
const Blockly = require('blockly');
const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
const setupAddCodeProperties = require('../../helpers/addCodeProperties');
const convertToBoolean = require('../../helpers/convertToBoolean');
const TOOLTIP = 'Container to hold Search Elements. ';

class SearchPane extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code, blocklyBlock) {
        const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
        addCodeProperties(['namespace', 'relation', { key: 'verticalLayout', handler: convertToBoolean }]);
        //backwards compatibility, it used to be that we would infer whether or not
        //we should display horizontally, from the absence of the title:
        if (!code.title && !code.verticalLayout) {
            code.horizontalLayout = true;
        }
        return JSON.stringify(code);
    }

    addToBlocksCustom(color, blocklyBlock) {
        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;
        blocklyBlock.setTooltip(TOOLTIP);

        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Namespace:')
            .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
            .appendField('  Relation:')
            .appendField(
                new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                'relation'
            );

        blocklyBlock
            .appendDummyInput('options')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Single Column Layout:')
            .appendField(new Blockly.FieldCheckbox(), 'verticalLayout');

        blocklyBlock
            .appendStatementInput('searchActionButtons')
            .setCheck(['actionElement', 'dialog', 'layout'])
            .appendField('Search Action Buttons:');

        blocklyBlock
            .appendStatementInput('children')
            .setCheck(['searchElement'])
            .appendField('Search Elements:', 'childrenField');
    }
}

module.exports = SearchPane;
